import { formatNumber } from '@angular/common';

export class DecimalUtils {
    // 123.45 -> 123
    // 12.345 -> 12   ;   if baseFraction = 2  -  12.345 -> 12.34
    // 1.2345 -> 1
    // 0.12345 -> 0.1
    // 0.012345 -> 0.01
    // 0.0012345 -> 0.001
    // 0.00012345 -> 0.0001
    // 0.000012345 -> 0.00001
    // 0.0000012345 -> 0.000001
    // ...
    static toFixed(v: number, baseFraction = 0): number {
        return +(v).toFixed(v >= 1 || v == 0 ? baseFraction : Math.max(baseFraction, Math.ceil(-Math.log10(v))));
    }

    static currencyFormatter = (v: number) => {
        return `$${formatNumber(+v, 'en', `1.0-${v < 10 ? '2' : '0'}`)}`;
    }
}
